import { Component, Type } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-four-sections-layout-component`,
    templateUrl: 'fourSectionsLayout.component.html',
    styleUrls: ['../layout.component.scss']
})

export class FourSectionsLayoutComponent extends LayoutComponent { }

export class FourSectionsLayout extends Layout {
    public type = 'FourSectionsLayout';
    public componentType = FourSectionsLayoutComponent;
    public numberOfSections = 4;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fourSectionsLayout/fourSectionsLayout.component.ts